<ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>

<ng-template #skeletonTableItem>
  <div class="col-12 d-flex flex-row gap-6">
    <!-- Reviewer avatar — now circular in the real content
         (review-table-widget.component.html), so the placeholder shape
         matches instead of resolving into a different one. -->
    <div class="skeleton rounded-circle h-50px w-50px"></div>
    <div class="d-flex flex-column justify-content-between flex-fill">
      <div>
        <div class="d-flex flex-row w-100 justify-content-between">
          <div class="skeleton w-100 mw-150px h-20px"></div>
          <div class="d-flex flex-row gap-3">
            <div class="skeleton w-15px h-15px"></div>
            <div class="skeleton w-15px h-15px"></div>
            <div class="skeleton w-15px h-15px"></div>
            <div class="skeleton w-15px h-15px"></div>
            <div class="skeleton w-15px h-15px"></div>
          </div>
        </div>
        <div class="skeleton w-100 mw-80px h-15px mt-2"></div>
      </div>
    </div>
  </div>
  <div class="mt-6">
    <div class="skeleton h-25px w-100 mb-4"></div>
    <div class="skeleton h-25px w-100 mb-4"></div>
  </div>
</ng-template>
